import { LicenceOrganisationSpecialisation } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationSpecialisation";
import { EmployeeTitleHelper } from "@/Common/Helpers/EmployeeTitleHelper";
import { EmployeeTitle } from "@/Common/Models/Employee/Enums/EmployeeTitle";
import { GeographicInfoCountry } from "@/Common/Models/Localization/GeographicInfoCountry";
import { MedfarDictionariesValidationHelper } from "@/ContactDirectory/Helpers/MedfarDictionariesValidationHelper";
import { DirectoryHealthCareProvider } from "@/ContactDirectory/Models//DirectoryHealthCareProvider";
import { BaseContactDirectoryValidator } from "./BaseContactDirectoryValidator";

export interface IHealthCareProviderValidationResult {
    firstName: boolean;
    lastName: boolean;
    licenseOrganizationRuleId: boolean;
    licenseOrganizationSpecializationId: boolean;
    licenseNumber: boolean;
    linkedEstablishments: boolean;
    linkedFaxNumbers: boolean;
    faxNumber: boolean;
    isFormValid: boolean;
    isEmployeeTitleValid: boolean;
}

export class DirectoryHealthCareProviderValidator extends BaseContactDirectoryValidator {
    public constructor(validationHelper: MedfarDictionariesValidationHelper, countries: GeographicInfoCountry[]) {
        super(validationHelper, countries);
    }

    public validate(model: DirectoryHealthCareProvider, specialtiesList: LicenceOrganisationSpecialisation[]): IHealthCareProviderValidationResult {
        const isFirstNameValid = !IsNullOrWhiteSpace(model.firstName);
        const isLastNameValid = !IsNullOrWhiteSpace(model.lastName);
        const isLicenseOrganizationRuleIdValid = !IsNullOrWhiteSpace(model.licenseOrganizationRuleId);
        const isLicenseOrganizationSpecializationIdValid = !specialtiesList?.any() || !IsNullOrWhiteSpace(model.licenseOrganizationSpecializationId);
        const licenseOrganizationRule = cacheStore.AllLicenseOrganizationRulesById[model.licenseOrganizationRuleId];

        // Need to review this for other organizations in the future. DoctorLegacy shouldn't be used at all.
        const isEmployeeTitleValid = licenseOrganizationRule?.OrganisationCode === "CPSO" ? licenseOrganizationRule?.Title !== EmployeeTitle.DoctorLegacy : true;
        const isLicenseNumberValid = !(EmployeeTitleHelper.isDoctor(licenseOrganizationRule?.Title) || EmployeeTitleHelper.isNurse(licenseOrganizationRule?.Title)) || !IsNullOrWhiteSpace(model.licenseNumber);
        const isLinkedEstablishmentsValid = model.linkedEstablishments?.any() && model.linkedEstablishments?.all(p => !!p.id);

        const isFaxNumberValid = this.isNumberValid(model.faxNumber);
        const hasFaxNumber = !!model?.faxNumber?.number && !!model?.faxNumber?.countryId;

        const isLinkedFaxNumbersValid = model.linkedFaxNumbers?.any()
            && model.linkedFaxNumbers?.length === model.linkedEstablishments.length;

        const isFormValid = isFirstNameValid
            && isEmployeeTitleValid
            && isLastNameValid
            && isLicenseOrganizationRuleIdValid
            && isLicenseOrganizationSpecializationIdValid
            && isLicenseNumberValid
            && ((hasFaxNumber && isFaxNumberValid) || (!hasFaxNumber && (isLinkedFaxNumbersValid && isLinkedEstablishmentsValid)));

        return {
            firstName: isFirstNameValid,
            lastName: isLastNameValid,
            licenseOrganizationRuleId: isLicenseOrganizationRuleIdValid,
            licenseOrganizationSpecializationId: isLicenseOrganizationSpecializationIdValid,
            licenseNumber: isLicenseNumberValid,
            linkedEstablishments: isLinkedEstablishmentsValid || isFaxNumberValid,
            linkedFaxNumbers: isLinkedFaxNumbersValid,
            faxNumber: isFaxNumberValid || isLinkedEstablishmentsValid,
            isEmployeeTitleValid,
            isFormValid
        };
    }
}
